export const spcDepartments = [
  "College of Computer Studies",
  "College of Criminology",
  "College of Education",
  "College of Business Administration",
  "College of Engineering",
  "College of Arts and Sciences",
];

export const times = [
  {
    startTime: 8,
    endTime: 9,
  },
  {
    startTime: 9,
    endTime: 10,
  },
  {
    startTime: 10,
    endTime: 11,
  },
  {
    startTime: 11,
    endTime: 12,
  },
  {
    startTime: 12,
    endTime: 13,
  },
  {
    startTime: 13,
    endTime: 14,
  },
  {
    startTime: 14,
    endTime: 15,
  },
  {
    startTime: 16,
    endTime: 17,
  },
  {
    startTime: 17,
    endTime: 18,
  },
  {
    startTime: 18,
    endTime: 19,
  },
  {
    startTime: 19,
    endTime: 20,
  },
];


export const StudentSidebarLinks = [
  {
    name: "Dashboard",
    link: "/private/Student/dashboard",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Appointment List",
    link: "/private/Student/dashboard/appointments",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: 'Pending Appointments',
    link: "/private/Student/dashboard/pending-appointments",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: 'Appointments Archive',
    link: "/private/Student/dashboard/appointments-archive",
    inAuthHide: false,
    beforeMDHide: true,
  }
]

export const GuidanceSidebarLinks = [
  {
    name: "Dashboard",
    link: "/private/Guidance/dashboard",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Appointments",
    link: "/private/Guidance/appointments/list",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Schedules",
    link: "/private/Guidance/schedules",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Student Counseling Services",
    link: "/private/Guidance/student-counseling-services",
    inAuthHide: false,
    beforeMDHide: true,
  },
]

export const FacultySidebarLinks = [
  {
    name: "Dashboard",
    link: "/private/Faculty/dashboard",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Appointments",
    link: "/private/Faculty/appointments",
    inAuthHide: false,
    beforeMDHide: true,
  },
  
  {
    name: "Schedules",
    link: "/private/Faculty/schedules",
    inAuthHide: false,
    beforeMDHide: true,
  },
];

export const AdminSidebarLinks = [
  {
    name: "Dashboard",
    link: "/private/Admin/dashboard",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Walkins",
    link: "/private/Admin/dashboard/walkins",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Pending Regs",
    link: "/private/Admin/dashboard/pending-registrations",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Appointments ",
    link: "/private/Admin/appointments",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Schedules",
    link: "/private/Admin/dashboard/schedules",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "Register User",
    link: "/private/Admin/dashboard/register-user",
    inAuthHide: false,
    beforeMDHide: true,
  },
  {
    name: "User List",
    link: "/private/Admin/dashboard/user-list",
    inAuthHide: false,
    beforeMDHide: true,
  },
];